module.exports = __webpack_public_path__ + "static/dominikawork3-0dad11a9b2be9c751d9cde3ed58790ee.jpg";